import { formatPrice } from "@lib/helpers";

const BrokerCommissionInfo = ({ offerDetails, withDirectSettlement }) => {
  const {
    brokerCommission: standardCommision,
    directSettlement: { brokerCommission: premiumCommision },
  } = offerDetails;

  const commision = withDirectSettlement
    ? (
        Number(standardCommision.amount) + Number(premiumCommision.amount)
      ).toFixed(2)
    : standardCommision.amount;

  return (
    <div>
      Comision inclus in pret: {standardCommision.percent}% (
      {formatPrice(Number(commision))} lei)
    </div>
  );
};

const RcaOffersListInfo = ({ offer, withDirectSettlement }) => {
  const { bonusMalusActualClass, referenceTariff, exclusionsGreenCard } =
    offer.offerDetails;

  const formatGreenCardExclusions = exclusionsGreenCard.includes(":")
    ? exclusionsGreenCard.split(":").pop().trim()
    : exclusionsGreenCard;

  return (
    <>
      {bonusMalusActualClass && (
        <div>Noua clasa Bonus-Malus: {bonusMalusActualClass}</div>
      )}

      {referenceTariff && (
        <div>Tarif de referinta: {formatPrice(referenceTariff)} lei</div>
      )}

      <BrokerCommissionInfo
        offerDetails={offer.offerDetails}
        withDirectSettlement={withDirectSettlement}
      />

      {exclusionsGreenCard && (
        <div>
          Tari neacoperite de polita de asigurare: {formatGreenCardExclusions}
        </div>
      )}
    </>
  );
};

export default RcaOffersListInfo;
